import React from "react";
import "./Gallery.css";

const images = [
  "https://twintravelcoron.com/testimonials/image1.jpg",
  "https://twintravelcoron.com/testimonials/image2.jpg",
  "https://twintravelcoron.com/testimonials/image3.jpg",
  "https://twintravelcoron.com/testimonials/image4.jpg",
  "https://twintravelcoron.com/testimonials/image5.jpg",
  "https://twintravelcoron.com/testimonials/image6.jpg",
  "https://twintravelcoron.com/testimonials/image7.jpg",
  "https://twintravelcoron.com/testimonials/image8.jpg",
  "https://twintravelcoron.com/testimonials/image9.jpg",
  "https://twintravelcoron.com/testimonials/image10.jpg",
  "https://twintravelcoron.com/testimonials/image11.jpg",
  "https://twintravelcoron.com/testimonials/image12.jpg",
];

const Gallery = () => {
  return (
    <div className="gallery-container">
      <div className="container">
        <h2 className="gallery-title">Gallery</h2>
        <div className="gallery-grid">
          {images.map((src, index) => (
            <div key={index} className="gallery-item">
              <img
                src={src}
                alt={`Gallery ${index + 1}`}
                className="gallery-image"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;
